import { render, staticRenderFns } from "./EntrypointEditModal.vue?vue&type=template&id=28482a6a&scoped=true&"
import script from "./EntrypointEditModal.vue?vue&type=script&lang=js&"
export * from "./EntrypointEditModal.vue?vue&type=script&lang=js&"
import style0 from "./EntrypointEditModal.vue?vue&type=style&index=0&id=28482a6a&prod&lang=scss&scoped=true&"
import style1 from "./EntrypointEditModal.vue?vue&type=style&index=1&id=28482a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28482a6a",
  null
  
)

export default component.exports